import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "workspace-layout" }
const _hoisted_2 = {
  key: 0,
  class: "workspace-panel workspace-panel--left"
}
const _hoisted_3 = {
  key: 1,
  class: "workspace-panel workspace-panel--center"
}
const _hoisted_4 = { class: "interaction-panel" }
const _hoisted_5 = {
  key: 0,
  class: "upcoming-meeting-wrapper"
}
const _hoisted_6 = ["aria-expanded"]
const _hoisted_7 = { class: "upcoming-meeting-banner__icon-wrap" }
const _hoisted_8 = { class: "upcoming-meeting-banner__body" }
const _hoisted_9 = { class: "upcoming-meeting-banner__title" }
const _hoisted_10 = { class: "upcoming-meeting-banner__detail" }
const _hoisted_11 = {
  key: 0,
  class: "upcoming-meetings-list"
}
const _hoisted_12 = { class: "upcoming-meetings-list__item-text" }
const _hoisted_13 = { class: "upcoming-meetings-list__item-title" }
const _hoisted_14 = { class: "upcoming-meetings-list__item-date" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "opportunity-banner__body" }
const _hoisted_17 = { class: "interaction-panels-container" }
const _hoisted_18 = {
  key: 2,
  class: "workspace-panel workspace-panel--right"
}
const _hoisted_19 = ["aria-expanded", "aria-pressed", "title"]
const _hoisted_20 = {
  key: 11,
  class: "post-call-loading-overlay"
}

import { ref, computed, watch, nextTick, onMounted, onUnmounted, useTemplateRef } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Icon } from "@iconify/vue";

import DeleteConfirmationModal from "@/components/modal/DeleteConfirmationModal.vue";
import CallInteractionHeader from "@/components/bucket/interactions/CallInteractionHeader.vue";
import CallInteractionPanel from "@/components/bucket/interactions/CallInteractionPanel.vue";
import EmailInteractionPanel from "@/components/bucket/interactions/EmailInteractionPanel.vue";
import WhatsAppInteractionPanel from "@/components/bucket/interactions/WhatsAppInteractionPanel.vue";
import LinkedInInteractionPanel from "@/components/bucket/interactions/LinkedInInteractionPanel.vue";
import DispositionReminderModal from "@/components/bucket/DispositionReminderModal.vue";
import EmailCompositionModal from "@/components/bucket/email/EmailCompositionModal.vue";
import LastInteractionModal from "@/components/bucket/LastInteractionModal.vue";
import LinkedInConnectionRequestModal from "@/components/bucket/linkedin/LinkedInConnectionRequestModal.vue";
import EditContactModal from "@/components/contacts/EditContactModal.vue";
import BookMeetingModal from "@/components/meeting/BookMeetingModal.vue";
import ReminderFollowupModal from "@/components/meeting/ReminderFollowupModal.vue";
import MeetingDetailsModal from "@/components/meeting/MeetingDetailsModal.vue";
import { useMeetings } from "@/composables/meetings/useMeetings";
import { useOpportunityByContact, useOpportunityStages } from "@/composables/opportunities";
import { OPPORTUNITY_OVERVIEW_ROUTE } from "@/router/routes";
import NotesModal from "@/components/note/NotesModal.vue";
import ForwardMessageModal from "@/components/socials/ForwardMessageModal.vue";
import StartWhatsAppChatModal from "@/components/socials/StartWhatsAppChatModal.vue";
import ConnectChannelModal from "@/components/socials/ConnectChannelModal.vue";
import TemplateViewerModal from "@/components/template/TemplateViewerModal.vue";
import TemplatesFloatingModal from "@/components/template/TemplatesFloatingModal.vue";
import Modal from "@/components/ui/Modal.vue";
import AIPersonalizationModal from "@/components/template/AIPersonalizationModal.vue";
import NextTaskFollowupModal from "@/components/bucket/NextTaskFollowupModal.vue";
import LinkedInProfileViewerModal from "@/components/bucket/linkedin/LinkedInProfileViewerModal.vue";
import CompanyProfileViewerModal from "@/components/bucket/company/CompanyProfileViewerModal.vue";
import SMSInteractionPanel from "@/components/bucket/interactions/SMSInteractionPanel.vue";
import ChatInteractionPanel from "@/components/bucket/interactions/ChatInteractionPanel.vue";

import { defineRule } from "vee-validate";

import { useMessageWebhooks } from "@/composables/messages/useMessageWebhooks";
import { useEmailWebhooks } from "@/composables/emails/useEmailWebhooks";

import { useToast } from "@/composables/ui/useToast";
import {
  useResponsiveBreakpoint,
  WORKSPACE_3UP_MIN_PX,
} from "@/composables/ui/useResponsiveBreakpoint";
import { usePersistentToggle } from "@/composables/ui/usePersistentToggle";
import { useICPs } from "@/composables/icp/useICPs";
import { disableBeforeUnload } from "@/utils/unloadGuard";
import { useDeleteContactPhoneNumber } from "@/composables/contacts";
import { useTaskFollowupContact } from "@/composables/bucket/useTaskFollowupContact";
import { usePostCallLock } from "@/composables/calls/usePostCallLock";
import { useCallLogBySid } from "@/composables/calls/useCallLogBySid";
import CallDispositionRequiredModal from "@/components/call-disposition/CallDispositionRequiredModal.vue";

// TanStack Query composables
import { useBucketOptions } from "@/composables/bucket/useBucketOptions";
import { useCallDispositions } from "@/composables/calls/useCallDispositions";
import { usePhoneNumbers } from "@/composables/calls/usePhoneNumbers";
import { useUpdateBucket, useRegisterBucket } from "@/composables/bucket/useBucket";
import { useLogCallLogDetails } from "@/composables/calls/useCallLog";
import { useRegisterActivityLog } from "@/composables/activityLogs/useRegisterActivityLog";

// Task-followup domain composables
import {
  useCallDispositionState,
  useChannelManager,
  useLinkedInActions,
  useEmailActions,
  useWhatsAppActions,
  useInteractionTabs,
  useSocketListeners,
  usePhoneSelection,
  useBucketForm,
} from "@/composables/task-followup";

// Define validation rules

export default /*@__PURE__*/_defineComponent({
  __name: 'TaskFollowupModal',
  props: {
    selectedBucket: {},
    incomingCallData: {},
    initialEmailThreadId: {},
    initialChatId: {}
  },
  emits: ["refreshBuckets", "closeTaskFollowupModal", "showMoveBucketModal"],
  setup(__props: any, { emit: __emit }) {

defineRule("email", (value: any) => {
  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegExp.test(value) || "Email is not valid";
});

defineRule("falseyEmail", (value: any) => {
  if (!value) {
    return true;
  }
  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegExp.test(value) || "Email is not valid";
});

defineRule("required", (value: any, [fieldName = "Field"]: any) => {
  if (!value || value.length === 0) {
    return `${fieldName} is required`;
  }
  return true;
});

defineRule("alpha", (value: any, [fieldName = "Field"]: any) => {
  const alphaRegExp = /^[a-zA-Z]*$/;
  return alphaRegExp.test(value) || `${fieldName} must contain only alphabetic characters`;
});

// Props
const props = __props;

// Emits
const emit = __emit;

// Globals
const store = useStore();
const router = useRouter();
const toast = useToast();

const account = computed(() => store.getters.account?.data);
const orgId = computed(() => account.value?.organizationId);

// TanStack Query data composables
const bucketOptionsParams = computed(() => (orgId.value ? { organizationId: orgId.value } : null));
const { data: bucketOptions } = useBucketOptions(bucketOptionsParams);

const { data: callDispositions } = useCallDispositions();

const phoneNumbersParams = computed(() => (orgId.value ? { organizationId: orgId.value } : null));
const { data: phoneNumbersResult } = usePhoneNumbers(phoneNumbersParams);
const phoneNumbers = computed(() => phoneNumbersResult.value?.data ?? []);

// ICPs
const { data: icpsData, isLoading: icpsLoading } = useICPs();
const icps = computed(() => icpsData.value ?? []);

// TanStack Query mutations
const { mutateAsync: updateBucket, isPending: isUpdatingBucket } = useUpdateBucket();
const { mutateAsync: registerBucket, isPending: isRegisteringBucket } = useRegisterBucket();
const bucketIsLoading = computed(() => isUpdatingBucket.value || isRegisteringBucket.value);
const { mutateAsync: logCallLogDetailsMutation, isPending: isLoggingDetails } =
  useLogCallLogDetails();
const { mutateAsync: registerActivityLog } = useRegisterActivityLog();

// Existing composables
const selectedBucketRef = computed(() => props.selectedBucket);
const { contact: reactiveContact } = useTaskFollowupContact(selectedBucketRef);
const { deleteContactPhoneNumber: deletePhoneMutation } = useDeleteContactPhoneNumber();

// Upcoming meetings for this contact (future only)
const upcomingMeetingsParams = computed(() => {
  const contactId = reactiveContact.value?.id;
  if (!orgId.value || !contactId) return null;
  return { organizationId: orgId.value, contactId, status: "pending", limit: 5 };
});
const { data: upcomingMeetingsData, refetch: refetchUpcomingMeetings } =
  useMeetings(upcomingMeetingsParams);
const nowRef = ref(new Date());
let _nowInterval: ReturnType<typeof setInterval> | null = null;
const upcomingMeetings = computed(() =>
  (upcomingMeetingsData.value?.data ?? []).filter(
    (m: any) => new Date(m.meetingDateTime) > nowRef.value
  )
);

const showUpcomingMeetingModal = ref(false);
const upcomingMeetingForModal = ref<any>(null);
const isUpcomingMeetingsExpanded = ref(false);

const toggleUpcomingMeetingsList = () => {
  isUpcomingMeetingsExpanded.value = !isUpcomingMeetingsExpanded.value;
};

const openUpcomingMeetingDetails = (meeting: any) => {
  if (!meeting) return;
  upcomingMeetingForModal.value = meeting;
  showUpcomingMeetingModal.value = true;
  isUpcomingMeetingsExpanded.value = false;
};

const formatUpcomingMeeting = (isoString: string) => {
  const d = new Date(isoString);
  return (
    d.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    }) +
    " · " +
    d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })
  );
};

const upcomingMeetingsTooltip = computed(() =>
  upcomingMeetings.value.map((m: any) => formatUpcomingMeeting(m.meetingDateTime)).join("  •  ")
);

// Opportunity this contact was converted to, if any (a contact has at most one)
const opportunityByContactParams = computed(() => {
  const contactId = reactiveContact.value?.id || props.selectedBucket?.contactId;
  if (!orgId.value || !contactId) return null;
  return { organizationId: orgId.value, contactId };
});
const { data: linkedOpportunity } = useOpportunityByContact(opportunityByContactParams);

// Opportunity.getOpportunities only returns a flat opportunityStageId (see
// OpportunityOverview.vue's own "currentStage" lookup), never a nested opportunityStage
// object, so the stage's name/colors have to be looked up separately from the org's
// stage list — same { organizationId } query OpportunityOverview.vue already uses, so
// this reuses that query's cache instead of firing a fresh request in most cases.
const opportunityStagesParams = computed(() => {
  if (!orgId.value) return null;
  return { organizationId: orgId.value };
});
const { data: opportunityStagesData } = useOpportunityStages(opportunityStagesParams);
const linkedOpportunityStage = computed(() => {
  const stages = opportunityStagesData.value;
  const stageId = linkedOpportunity.value?.opportunityStageId;
  if (!Array.isArray(stages) || !stageId) return null;
  return stages.find((stage) => stage.id === stageId) || null;
});

const hexToRgba = (hex: string | undefined | null, alpha: number) => {
  if (!hex || typeof hex !== "string" || !hex.startsWith("#") || hex.length < 7) return null;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// Colored entirely from the opportunity's own stage (not a fixed palette), so the
// banner always matches whatever color the org configured for that stage.
const opportunityBannerColors = computed(() => {
  const stage = linkedOpportunityStage.value;
  const text = stage?.textColor || "#4338ca";
  return {
    background: stage?.backgroundColor || hexToRgba(text, 0.08) || "#eef2ff",
    border: hexToRgba(text, 0.35) || "#c7d2fe",
    iconBackground: hexToRgba(text, 0.16) || "#e0e7ff",
    text,
  };
});

// Same pill treatment used for opportunity stages in the contact activity timeline
// (see MovementTimelineItem.vue's pillStyle helper) — tinted background from the
// stage color at ~12% opacity, solid border/text in the stage color itself. Routed
// through hexToRgba (rather than string-concatenating a hex alpha suffix) so it
// doesn't break on 3-digit hex stage colors.
const stagePillStyle = computed(() => {
  const color = linkedOpportunityStage.value?.textColor || "#6b7280";
  return {
    backgroundColor: hexToRgba(color, 0.12) || color + "20",
    color,
    borderColor: color,
  };
});

const goToLinkedOpportunity = () => {
  if (!linkedOpportunity.value?.id) return;
  router.push({ name: OPPORTUNITY_OVERVIEW_ROUTE, params: { id: linkedOpportunity.value.id } });
};

const {
  isPostCallLocked,
  isDispositionPending,
  pendingCallSid,
  onCallSummaryReady,
  onDispositionSaved,
  clearPostCallLock,
} = usePostCallLock();

const { data: pendingCallLog, isLoading: callLogLoading } = useCallLogBySid(pendingCallSid, orgId);

watch([callLogLoading, pendingCallLog], ([loading, callLog]) => {
  if (!pendingCallSid.value) return;
  if (!loading && callLog) onCallSummaryReady();
});

const currentCallSid = ref<string | null>(null);
const parentCallSid = ref<string | null>(null);
const lastCallSid = ref<string | null>(null);
const to = ref<string>("");

const {
  selectedCallDisposition,
  callDispositionError,
  mustLogAfterCall,
  hasCallBeenLogged,
  hasBaseCallLogCreated,
  isCallDispositionRequired,
  canProceedWithCall,
  logCallBySid,
  onCallDispositionChange,
} = useCallDispositionState(
  currentCallSid,
  logCallLogDetailsMutation,
  callDispositions,
  reactiveContact,
  toast
);

const {
  whatsAppChannel,
  linkedInChannel,
  emailChannel,
  emailAccounts,
  isChannelsLoading,
  showConnectChannelModal,
  channelToConnect,
  isConnectingChannel,
  isEmailAccountConnected,
  availableChannelsForChat,
  isChannelHealthyStatus,
  loadChannels,
  getChannelForType,
  handleConnectEmailAccount,
  handleReconnectLinkedIn,
  handleReconnectWhatsApp,
  handleConnectChannel,
} = useChannelManager(toast);

// Interaction tabs first (provides loadConversationsForChannel)
const {
  activeInteractionTab,
  interactionTabs,
  isLoadingConversations,
  tabsWithBadges,
  interactionCounts,
  incrementBadge,
  mapTaskTypeToTab,
  loadConversationsForChannel,
} = useInteractionTabs(props, reactiveContact, () => props.incomingCallData);

const {
  isSendingLinkedInInvite,
  linkedInInviteError,
  showLinkedInConnectionModal,
  showLinkedInProfileModal,
  showCompanyProfileModal,
  canSendLinkedInInvite,
  extractLinkedInIdentifierFromUrl,
  handleLinkedInConnectionModalClose,
  handleLinkedInConnectionSend,
} = useLinkedInActions(
  reactiveContact,
  linkedInChannel,
  isChannelHealthyStatus,
  loadConversationsForChannel,
  toast
);

const { showEmailCompositionModal, handleEmailSend, handleEmailAttach, handleEmailScheduleSend } =
  useEmailActions(loadConversationsForChannel, toast);

const {
  forwardingMessage,
  showForwardModal,
  showStartChatModal,
  isCreatingChat,
  forwardableConversations,
  handleCreateChat,
  handleForwardConfirm,
  handleForwardSearch,
  handleForwardLoadMore,
} = useWhatsAppActions(activeInteractionTab, loadConversationsForChannel, toast);

const {
  selectedNumber,
  selectedNumberObj,
  selectedContactNumber,
  showMicrophoneDropdown,
  showDialerDropdown,
  showIVRDropdown,
  searchTerm,
  showSearchDropdown,
  allContactNumbers,
  validContactNumbers,
  contactPhoneNumbers,
  getRecipientPhoneNumber,
  hasValidPhoneNumber,
  onPhoneNumberChange,
  formatPhoneNumberWithCountry,
  toggleDeleteContactPhoneNumber,
  deleteContactPhoneNumber,
  getPhoneNumbers,
  selectMicrophone,
  handleClickOutside,
  handleDialerClickOutside,
  toggleDialerDropdown,
  selectPhoneNumberToEdit,
  handlePhoneDataChange,
  showPhoneNumberMenu,
  getContacts,
  debouncedSearch,
  debouncedSearchFunc,
  selectContact,
  copyToClipboard,
} = usePhoneSelection(reactiveContact, phoneNumbers, deletePhoneMutation, store, account, toast);

const { setupSocketListeners, cleanupSocketListeners } = useSocketListeners(
  parentCallSid,
  currentCallSid,
  lastCallSid,
  to,
  loadChannels
);

const {
  editBucketObj,
  selectedFollowUpOption,
  selectedMeeting,
  nextTaskKey,
  showCloseConfirmationModal,
  taskTypeOptions,
  bucketOptionsFormatted,
  followUpOnOptions,
  setValues,
  closeModal,
  editBucket,
  handleSaveAndLogCall,
  handleNextTaskSave,
  handleCancel,
  handlePromptSelectDisposition,
  openReminderFollowupModal,
  closeParentModal,
  closeReminderFollowupModal,
} = useBucketForm(
  props,
  emit,
  updateBucket,
  registerBucket,
  registerActivityLog,
  logCallBySid,
  isCallDispositionRequired,
  selectedCallDisposition,
  callDispositionError,
  mustLogAfterCall,
  currentCallSid,
  hasCallBeenLogged,
  isPostCallLocked,
  account,
  reactiveContact,
  bucketOptions,
  toast,
  router
);

// Cross-cutting UI state (stays in component)
const showModal = ref(true);

const { matches: is3Up } = useResponsiveBreakpoint(WORKSPACE_3UP_MIN_PX);
const {
  value: isTemplatesOpen,
  toggle: toggleTemplatesModal,
  close: closeTemplatesModal,
} = usePersistentToggle("sb_workspace_templates_drawer", false);

function isEditableFocus(): boolean {
  const el = document.activeElement as HTMLElement | null;
  if (!el) return false;
  const tag = el.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
  if (el.isContentEditable) return true;
  return false;
}

function handleWorkspaceKeydown(e: KeyboardEvent) {
  if (!showModal.value) return;

  if (e.key === "Escape") {
    if (isPostCallLocked.value) return;
    if (!is3Up.value && isTemplatesOpen.value) {
      e.preventDefault();
      closeTemplatesModal();
      return;
    }
    closeModal();
    return;
  }

  if (e.key === "]") {
    if (is3Up.value) return;
    if (isEditableFocus()) return;
    e.preventDefault();
    toggleTemplatesModal();
  }
}

const showAiPersonalizationModal = ref(false);
const aiPersonalizationContext = ref({
  defaultType: "",
  contactName: "",
  icpName: "",
  contactId: "",
  icpId: "",
});

const showNotesModal = ref(false);
const showLastInteractionModal = ref(false);
const showBookMeetingModal = ref(false);
const showReminderFollowupModal = ref(false);
const showEditContactModal = ref(false);
const showDeleteConfirmationModal = ref(false);
const pendingCueCardContent = ref<any>(null);

// Set when an Interaction History entry is clicked, to auto-open that
// specific conversation in the matching channel panel. `undefined` means
// "no history click yet" (fall back to the initial prop); `null` is a
// deliberate "this activity log had no captured conversation id" — it must
// NOT fall back, or clicking such an entry would reopen a stale conversation.
const historyEmailThreadId = ref<string | null | undefined>(undefined);
const historyLinkedInChatId = ref<string | null | undefined>(undefined);
const historyWhatsAppChatId = ref<string | null | undefined>(undefined);

// The specific message to scroll to/highlight once the conversation above opens.
const historyLinkedInMessageId = ref<string | null>(null);
const historyWhatsAppMessageId = ref<string | null>(null);

// Computed properties for cross-cutting concerns
const contactFullName = computed(() =>
  `${reactiveContact.value?.fname || ""} ${reactiveContact.value?.lname || ""}`.trim()
);

const effectiveEmailThreadId = computed(() =>
  historyEmailThreadId.value !== undefined
    ? historyEmailThreadId.value
    : (props.initialEmailThreadId ?? null)
);
const effectiveLinkedInChatId = computed(() =>
  historyLinkedInChatId.value !== undefined
    ? historyLinkedInChatId.value
    : (props.initialChatId ?? null)
);
const effectiveWhatsAppChatId = computed(() =>
  historyWhatsAppChatId.value !== undefined
    ? historyWhatsAppChatId.value
    : (props.initialChatId ?? null)
);

// Cross-cutting handlers
function handleSwitchChannelWithContent(payload: any) {
  const channelToTab: any = {
    call: "calls",
    email: "email",
    linkedin_connection: "linkedin",
    linkedin_followup: "linkedin",
    whatsapp: "whatsapp",
    sms: "sms",
  };
  const targetTab = channelToTab[payload.channel] || "calls";
  pendingCueCardContent.value = payload;
  activeInteractionTab.value = targetTab;
}

function handleOpenAiPersonalization(payload: any) {
  aiPersonalizationContext.value = {
    defaultType: payload.defaultType || "",
    contactName: payload.contactName || "",
    icpName: payload.icpName || "",
    contactId: payload.contactId || "",
    icpId: payload.icpId || "",
  };
  showAiPersonalizationModal.value = true;
}

function handleDeclineIncomingCall() {
  emit("closeTaskFollowupModal");
}

function handleNavigateFromInteractionHistory(
  tab: string,
  conversationId: string | null,
  messageId: string | null
) {
  showLastInteractionModal.value = false;
  if (tab === "email") {
    historyEmailThreadId.value = conversationId;
  } else if (tab === "linkedin") {
    historyLinkedInChatId.value = conversationId;
    historyLinkedInMessageId.value = messageId;
  } else if (tab === "whatsapp") {
    historyWhatsAppChatId.value = conversationId;
    historyWhatsAppMessageId.value = messageId;
  }
  activeInteractionTab.value = tab;
}

function getContact() {
  emit("refreshBuckets");
}

// Webhook composables
useMessageWebhooks({
  onLinkedInMessage: (payload) => {
    loadConversationsForChannel("linkedin");
    if (reactiveContact.value?.id && payload?.contactId === reactiveContact.value.id) {
      incrementBadge("linkedin");
    }
  },
  onWhatsAppMessage: (payload) => {
    loadConversationsForChannel("whatsapp");
    if (reactiveContact.value?.id && payload?.contactId === reactiveContact.value.id) {
      incrementBadge("whatsapp");
    }
  },
});

useEmailWebhooks({
  accountId: computed(() => emailChannel.value?.accountId) as any,
  isEmailChannelSelected: computed(() => activeInteractionTab.value === "email") as any,
  onEmailReceived: (payload: any, helpers: any) => {
    try {
      if (!helpers.belongsToAccount(payload)) {
        return;
      }
      if (activeInteractionTab.value === "email") {
        loadConversationsForChannel("email");
      }
      if (reactiveContact.value?.id && payload?.contactId === reactiveContact.value.id) {
        incrementBadge("email");
      }
    } catch (error) {
      console.error("Error handling email received event:", error);
    }
  },
  onEmailOpened: () => {},
  onEmailLinkClicked: () => {},
  showNotifications: false,
});

// Lifecycle hooks
onMounted(async () => {
  setValues();
  await loadChannels();
  setupSocketListeners();
  document.addEventListener("keydown", handleWorkspaceKeydown);
  _nowInterval = setInterval(() => {
    nowRef.value = new Date();
  }, 60_000);
});

onUnmounted(() => {
  disableBeforeUnload();
  cleanupSocketListeners();
  document.removeEventListener("mousedown", handleClickOutside);
  document.removeEventListener("click", handleClickOutside);
  document.removeEventListener("keydown", handleWorkspaceKeydown);
  if (_nowInterval) clearInterval(_nowInterval);
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Modal, {
      show: showModal.value,
      size: "full",
      "show-close-button": false,
      "close-on-backdrop": !_unref(isPostCallLocked),
      "close-on-escape": false,
      "blur-backdrop": true,
      onClose: _cache[30] || (_cache[30] = ($event: any) => (_unref(closeModal)()))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (__props.selectedBucket && _unref(is3Up))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(TemplateViewerModal, {
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(closeModal)()))
                })
              ]))
            : _createCommentVNode("", true),
          (__props.selectedBucket)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(CallInteractionHeader, {
                    activeTab: _unref(activeInteractionTab),
                    "onUpdate:activeTab": _cache[1] || (_cache[1] = ($event: any) => (_isRef(activeInteractionTab) ? (activeInteractionTab).value = $event : null)),
                    contact: _unref(reactiveContact),
                    tabs: _unref(tabsWithBadges),
                    onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(closeModal)()))
                  }, null, 8, ["activeTab", "contact", "tabs"]),
                  (upcomingMeetings.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", {
                          class: "upcoming-meeting-banner",
                          role: "button",
                          tabindex: "0",
                          "aria-expanded": isUpcomingMeetingsExpanded.value,
                          onClick: toggleUpcomingMeetingsList,
                          onKeydown: _withKeys(toggleUpcomingMeetingsList, ["enter"])
                        }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_unref(Icon), {
                              icon: "mdi:calendar-check",
                              width: "15",
                              height: "15"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(upcomingMeetings.value.length === 1
                          ? "Meeting Scheduled"
                          : `${upcomingMeetings.value.length} Meetings Scheduled`), 1),
                            _createElementVNode("span", _hoisted_10, [
                              _createTextVNode(_toDisplayString(formatUpcomingMeeting(upcomingMeetings.value[0].meetingDateTime)) + " ", 1),
                              (upcomingMeetings.value.length > 1)
                                ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "upcoming-meeting-banner__more",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createVNode(_unref(Icon), {
                                      icon: "mdi:information-outline",
                                      width: "11",
                                      height: "11"
                                    }),
                                    _createTextVNode(" +" + _toDisplayString(upcomingMeetings.value.length - 1) + " more ", 1)
                                  ])), [
                                    [_directive_tooltip, { content: upcomingMeetingsTooltip.value, placement: 'bottom' }]
                                  ])
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode(_unref(Icon), {
                            icon: "mdi:chevron-right",
                            class: _normalizeClass(["upcoming-meeting-banner__chevron", {
                      'upcoming-meeting-banner__chevron--expanded': isUpcomingMeetingsExpanded.value,
                    }]),
                            width: "16",
                            height: "16"
                          }, null, 8, ["class"])
                        ], 40, _hoisted_6),
                        (isUpcomingMeetingsExpanded.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(upcomingMeetings.value, (meeting) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: meeting.id,
                                  class: "upcoming-meetings-list__item"
                                }, [
                                  _createVNode(_unref(Icon), {
                                    icon: "mdi:calendar-clock-outline",
                                    class: "upcoming-meetings-list__item-icon"
                                  }),
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(meeting.title || "Meeting"), 1),
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(formatUpcomingMeeting(meeting.meetingDateTime)), 1)
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "upcoming-meetings-list__item-action",
                                    onClick: ($event: any) => (openUpcomingMeetingDetails(meeting))
                                  }, " See Details ", 8, _hoisted_15)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(linkedOpportunity))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "opportunity-banner",
                        style: _normalizeStyle({
                  background: opportunityBannerColors.value.background,
                  borderBottomColor: opportunityBannerColors.value.border,
                })
                      }, [
                        _createElementVNode("div", {
                          class: "opportunity-banner__icon-wrap",
                          style: _normalizeStyle({
                    background: opportunityBannerColors.value.iconBackground,
                    color: opportunityBannerColors.value.text,
                  })
                        }, [
                          _createVNode(_unref(Icon), {
                            icon: "mdi:briefcase-check-outline",
                            width: "15",
                            height: "15"
                          })
                        ], 4),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("span", {
                            class: "opportunity-banner__title",
                            style: _normalizeStyle({ color: opportunityBannerColors.value.text })
                          }, " Opportunity ", 4),
                          (linkedOpportunityStage.value?.name)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "opportunity-banner__stage-pill",
                                style: _normalizeStyle(stagePillStyle.value)
                              }, _toDisplayString(linkedOpportunityStage.value.name), 5))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: "opportunity-banner__detail",
                            style: _normalizeStyle({ color: opportunityBannerColors.value.text })
                          }, _toDisplayString(_unref(linkedOpportunity).name), 5)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "opportunity-banner__view",
                          style: _normalizeStyle({ color: opportunityBannerColors.value.text }),
                          onClick: goToLinkedOpportunity
                        }, [
                          _cache[49] || (_cache[49] = _createTextVNode(" View ", -1)),
                          _createVNode(_unref(Icon), {
                            icon: "mdi:arrow-top-right",
                            width: "12",
                            height: "12"
                          })
                        ], 4)
                      ], 4))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createVNode(CallInteractionPanel, {
                      "is-active": _unref(activeInteractionTab) === 'calls',
                      selectedBucket: __props.selectedBucket,
                      contact: _unref(reactiveContact),
                      incomingCallData: __props.incomingCallData,
                      icps: icps.value,
                      "icp-loading": _unref(icpsLoading),
                      pendingCueCardContent: pendingCueCardContent.value,
                      onRefreshBuckets: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('refreshBuckets'))),
                      onSaveAndLogCall: _unref(handleSaveAndLogCall),
                      onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_unref(closeModal)())),
                      onShowEditContactModal: _cache[6] || (_cache[6] = ($event: any) => (showEditContactModal.value = true)),
                      onDeclineIncomingCall: handleDeclineIncomingCall,
                      onOpenAiPersonalization: handleOpenAiPersonalization,
                      onSwitchChannel: handleSwitchChannelWithContent,
                      onContentApplied: _cache[7] || (_cache[7] = ($event: any) => (pendingCueCardContent.value = null))
                    }, null, 8, ["is-active", "selectedBucket", "contact", "incomingCallData", "icps", "icp-loading", "pendingCueCardContent", "onSaveAndLogCall"]), [
                      [_vShow, _unref(activeInteractionTab) === 'calls']
                    ]),
                    _withDirectives(_createVNode(WhatsAppInteractionPanel, {
                      "is-active": _unref(activeInteractionTab) === 'whatsapp',
                      selectedBucket: __props.selectedBucket,
                      contact: _unref(reactiveContact),
                      whatsAppChannel: _unref(whatsAppChannel),
                      icps: icps.value,
                      "icp-loading": _unref(icpsLoading),
                      "is-channels-loading": _unref(isChannelsLoading),
                      initialConversationId: effectiveWhatsAppChatId.value,
                      "initial-message-id": historyWhatsAppMessageId.value,
                      onRefreshConversations: _cache[8] || (_cache[8] = ($event: any) => (_unref(loadConversationsForChannel)('whatsapp'))),
                      onMessageSent: _cache[9] || (_cache[9] = ($event: any) => (_unref(loadConversationsForChannel)('whatsapp'))),
                      onShowEditContactModal: _cache[10] || (_cache[10] = ($event: any) => (showEditContactModal.value = true)),
                      onReconnectRequested: _unref(handleReconnectWhatsApp),
                      onOpenAiPersonalization: handleOpenAiPersonalization,
                      onSwitchChannel: handleSwitchChannelWithContent,
                      pendingCueCardContent: pendingCueCardContent.value,
                      onContentApplied: _cache[11] || (_cache[11] = ($event: any) => (pendingCueCardContent.value = null))
                    }, null, 8, ["is-active", "selectedBucket", "contact", "whatsAppChannel", "icps", "icp-loading", "is-channels-loading", "initialConversationId", "initial-message-id", "onReconnectRequested", "pendingCueCardContent"]), [
                      [_vShow, _unref(activeInteractionTab) === 'whatsapp']
                    ]),
                    _withDirectives(_createVNode(LinkedInInteractionPanel, {
                      "is-active": _unref(activeInteractionTab) === 'linkedin',
                      selectedBucket: __props.selectedBucket,
                      linkedInChannel: _unref(linkedInChannel),
                      icps: icps.value,
                      "icp-loading": _unref(icpsLoading),
                      "is-channels-loading": _unref(isChannelsLoading),
                      initialConversationId: effectiveLinkedInChatId.value,
                      "initial-message-id": historyLinkedInMessageId.value,
                      onRefreshConversations: _cache[12] || (_cache[12] = ($event: any) => (_unref(loadConversationsForChannel)('linkedin'))),
                      onMessageSent: _cache[13] || (_cache[13] = ($event: any) => (_unref(loadConversationsForChannel)('linkedin'))),
                      onShowEditContactModal: _cache[14] || (_cache[14] = ($event: any) => (showEditContactModal.value = true)),
                      onReconnectRequested: _unref(handleReconnectLinkedIn),
                      onOpenAiPersonalization: handleOpenAiPersonalization,
                      onSwitchChannel: handleSwitchChannelWithContent,
                      pendingCueCardContent: pendingCueCardContent.value,
                      onContentApplied: _cache[15] || (_cache[15] = ($event: any) => (pendingCueCardContent.value = null))
                    }, null, 8, ["is-active", "selectedBucket", "linkedInChannel", "icps", "icp-loading", "is-channels-loading", "initialConversationId", "initial-message-id", "onReconnectRequested", "pendingCueCardContent"]), [
                      [_vShow, _unref(activeInteractionTab) === 'linkedin']
                    ]),
                    _withDirectives(_createVNode(EmailInteractionPanel, {
                      "is-active": _unref(activeInteractionTab) === 'email',
                      selectedBucket: __props.selectedBucket,
                      emailChannel: _unref(emailChannel),
                      emailAccounts: _unref(emailAccounts),
                      icps: icps.value,
                      "icp-loading": _unref(icpsLoading),
                      "is-channels-loading": _unref(isChannelsLoading),
                      "initial-thread-id": effectiveEmailThreadId.value,
                      onRefreshConversations: _cache[16] || (_cache[16] = ($event: any) => (_unref(loadConversationsForChannel)('email'))),
                      onEmailSent: _cache[17] || (_cache[17] = ($event: any) => (_unref(loadConversationsForChannel)('email'))),
                      onConnectAccount: _unref(handleConnectEmailAccount),
                      onOpenAiPersonalization: handleOpenAiPersonalization,
                      onSwitchChannel: handleSwitchChannelWithContent,
                      pendingCueCardContent: pendingCueCardContent.value,
                      onContentApplied: _cache[18] || (_cache[18] = ($event: any) => (pendingCueCardContent.value = null))
                    }, null, 8, ["is-active", "selectedBucket", "emailChannel", "emailAccounts", "icps", "icp-loading", "is-channels-loading", "initial-thread-id", "onConnectAccount", "pendingCueCardContent"]), [
                      [_vShow, _unref(activeInteractionTab) === 'email']
                    ]),
                    _withDirectives(_createVNode(SMSInteractionPanel, {
                      "is-active": _unref(activeInteractionTab) === 'sms',
                      selectedBucket: __props.selectedBucket,
                      contact: _unref(reactiveContact),
                      icps: icps.value,
                      "icp-loading": _unref(icpsLoading),
                      "is-channels-loading": _unref(isChannelsLoading),
                      onRefreshConversations: _cache[19] || (_cache[19] = ($event: any) => (_unref(loadConversationsForChannel)('sms'))),
                      onMessageSent: _cache[20] || (_cache[20] = ($event: any) => (_unref(loadConversationsForChannel)('sms'))),
                      onShowEditContactModal: _cache[21] || (_cache[21] = ($event: any) => (showEditContactModal.value = true)),
                      onOpenAiPersonalization: handleOpenAiPersonalization,
                      onSwitchChannel: handleSwitchChannelWithContent,
                      pendingCueCardContent: pendingCueCardContent.value,
                      onContentApplied: _cache[22] || (_cache[22] = ($event: any) => (pendingCueCardContent.value = null))
                    }, null, 8, ["is-active", "selectedBucket", "contact", "icps", "icp-loading", "is-channels-loading", "pendingCueCardContent"]), [
                      [_vShow, _unref(activeInteractionTab) === 'sms']
                    ]),
                    _withDirectives(_createVNode(ChatInteractionPanel, {
                      "is-active": _unref(activeInteractionTab) === 'chat',
                      selectedBucket: __props.selectedBucket
                    }, null, 8, ["is-active", "selectedBucket"]), [
                      [_vShow, _unref(activeInteractionTab) === 'chat']
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.selectedBucket)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(), _createBlock(NextTaskFollowupModal, {
                  key: _unref(nextTaskKey),
                  selectedBucket: __props.selectedBucket,
                  contact: _unref(reactiveContact),
                  bucketIsLoading: bucketIsLoading.value,
                  bucketOptions: _unref(bucketOptions),
                  onClose: _cache[23] || (_cache[23] = ($event: any) => (_unref(closeModal)())),
                  onSave: _unref(handleNextTaskSave),
                  onShowNotesModal: _cache[24] || (_cache[24] = ($event: any) => (showNotesModal.value = true)),
                  onShowLastInteractionModal: _cache[25] || (_cache[25] = ($event: any) => (showLastInteractionModal.value = true)),
                  onShowEditContactModal: _cache[26] || (_cache[26] = ($event: any) => (showEditContactModal.value = true)),
                  onShowBookMeetingModal: _cache[27] || (_cache[27] = ($event: any) => (showBookMeetingModal.value = true)),
                  onShowLinkedinProfileModal: _cache[28] || (_cache[28] = ($event: any) => (showLinkedInProfileModal.value = true)),
                  onShowCompanyProfileModal: _cache[29] || (_cache[29] = ($event: any) => (showCompanyProfileModal.value = true))
                }, null, 8, ["selectedBucket", "contact", "bucketIsLoading", "bucketOptions", "onSave"]))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show", "close-on-backdrop"]),
    (showModal.value && __props.selectedBucket && !_unref(is3Up))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: _normalizeClass(["templates-fab", { active: _unref(isTemplatesOpen) }]),
          "aria-expanded": _unref(isTemplatesOpen),
          "aria-pressed": _unref(isTemplatesOpen),
          title: _unref(isTemplatesOpen) ? 'Close templates (])' : 'Open templates (])',
          onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_unref(toggleTemplatesModal) && _unref(toggleTemplatesModal)(...args)))
        }, [
          _createVNode(_unref(Icon), {
            icon: "mdi:file-document-outline",
            width: "15",
            height: "15"
          }),
          _cache[50] || (_cache[50] = _createElementVNode("span", null, "Templates", -1))
        ], 10, _hoisted_19))
      : _createCommentVNode("", true),
    (!_unref(is3Up))
      ? (_openBlock(), _createBlock(TemplatesFloatingModal, {
          key: 1,
          show: _unref(isTemplatesOpen) && Boolean(__props.selectedBucket),
          onClose: _unref(closeTemplatesModal)
        }, null, 8, ["show", "onClose"]))
      : _createCommentVNode("", true),
    (showNotesModal.value == true)
      ? (_openBlock(), _createBlock(NotesModal, {
          key: 2,
          selectedContact: _unref(reactiveContact),
          onCloseNotesModal: _cache[32] || (_cache[32] = ($event: any) => (showNotesModal.value = false))
        }, null, 8, ["selectedContact"]))
      : _createCommentVNode("", true),
    (showBookMeetingModal.value == true)
      ? (_openBlock(), _createBlock(BookMeetingModal, {
          key: 3,
          selectedBucket: __props.selectedBucket,
          onCloseBookMeetingModal: _cache[33] || (_cache[33] = ($event: any) => (showBookMeetingModal.value = false)),
          onShowReminderFollowupModal: _cache[34] || (_cache[34] = 
        (meeting) => {
          _unref(openReminderFollowupModal)(meeting);
          showReminderFollowupModal.value = true;
        }
      )
        }, null, 8, ["selectedBucket"]))
      : _createCommentVNode("", true),
    (showReminderFollowupModal.value == true)
      ? (_openBlock(), _createBlock(ReminderFollowupModal, {
          key: 4,
          selectedMeeting: _unref(selectedMeeting),
          onCloseReminderFollowupModal: _cache[35] || (_cache[35] = ($event: any) => {
        showReminderFollowupModal.value = false;
        _unref(closeReminderFollowupModal)();
      }),
          onCloseParentModal: _unref(closeParentModal)
        }, null, 8, ["selectedMeeting", "onCloseParentModal"]))
      : _createCommentVNode("", true),
    (showUpcomingMeetingModal.value)
      ? (_openBlock(), _createBlock(MeetingDetailsModal, {
          key: 5,
          selectedMeeting: upcomingMeetingForModal.value,
          onCloseMeetingDetailsModal: _cache[36] || (_cache[36] = ($event: any) => (showUpcomingMeetingModal.value = false)),
          onRefreshMeetings: _unref(refetchUpcomingMeetings)
        }, null, 8, ["selectedMeeting", "onRefreshMeetings"]))
      : _createCommentVNode("", true),
    (showEditContactModal.value == true)
      ? (_openBlock(), _createBlock(EditContactModal, {
          key: 6,
          selectedContact: _unref(reactiveContact),
          onCloseEditContactModal: _cache[37] || (_cache[37] = ($event: any) => (showEditContactModal.value = false)),
          onRefreshContacts: _cache[38] || (_cache[38] = ($event: any) => (getContact()))
        }, null, 8, ["selectedContact"]))
      : _createCommentVNode("", true),
    (showLastInteractionModal.value == true)
      ? (_openBlock(), _createBlock(LastInteractionModal, {
          ref: "lastInteractionModal",
          contactId: _unref(reactiveContact)?.id || __props.selectedBucket?.contactId,
          "contact-email": _unref(reactiveContact)?.email || '',
          key: _unref(reactiveContact)?.id ?? __props.selectedBucket?.contactId ?? 'loading',
          onCloseLastInteractionModal: _cache[39] || (_cache[39] = ($event: any) => (showLastInteractionModal.value = false)),
          onNavigateToTab: handleNavigateFromInteractionHistory
        }, null, 8, ["contactId", "contact-email"]))
      : _createCommentVNode("", true),
    (showDeleteConfirmationModal.value == true)
      ? (_openBlock(), _createBlock(DeleteConfirmationModal, {
          key: 8,
          deleteFunction: _unref(deleteContactPhoneNumber),
          entity: "Phone Number",
          onCloseDeleteConfirmationModal: _cache[40] || (_cache[40] = ($event: any) => (showDeleteConfirmationModal.value = false)),
          onRefreshRecords: _cache[41] || (_cache[41] = ($event: any) => (getContact()))
        }, null, 8, ["deleteFunction"]))
      : _createCommentVNode("", true),
    _createVNode(ForwardMessageModal, {
      show: _unref(showForwardModal),
      conversations: _unref(forwardableConversations),
      "channel-type": _unref(activeInteractionTab),
      "is-loading": _unref(isLoadingConversations),
      "is-loading-more": false,
      "has-more": false,
      onClose: _cache[42] || (_cache[42] = ($event: any) => (showForwardModal.value = false)),
      onForward: _unref(handleForwardConfirm),
      onSearch: _unref(handleForwardSearch),
      onLoadMore: _unref(handleForwardLoadMore)
    }, null, 8, ["show", "conversations", "channel-type", "is-loading", "onForward", "onSearch", "onLoadMore"]),
    (_unref(showCloseConfirmationModal))
      ? (_openBlock(), _createBlock(DispositionReminderModal, {
          key: 9,
          isLoading: bucketIsLoading.value || _unref(isLoggingDetails),
          selectedCallDisposition: _unref(selectedCallDisposition),
          onCancel: _unref(handleCancel)
        }, null, 8, ["isLoading", "selectedCallDisposition", "onCancel"]))
      : _createCommentVNode("", true),
    (_unref(showEmailCompositionModal))
      ? (_openBlock(), _createBlock(EmailCompositionModal, {
          key: 10,
          show: _unref(showEmailCompositionModal),
          "recipient-email": _unref(reactiveContact)?.email,
          accounts: _unref(emailAccounts),
          "default-account-id": _unref(emailChannel)?.accountId,
          "contact-id": _unref(reactiveContact)?.id || __props.selectedBucket?.contactId || '',
          onClose: _cache[43] || (_cache[43] = ($event: any) => (showEmailCompositionModal.value = false)),
          onSend: _unref(handleEmailSend),
          onAttach: _unref(handleEmailAttach),
          onScheduleSend: _unref(handleEmailScheduleSend)
        }, null, 8, ["show", "recipient-email", "accounts", "default-account-id", "contact-id", "onSend", "onAttach", "onScheduleSend"]))
      : _createCommentVNode("", true),
    _createVNode(LinkedInConnectionRequestModal, {
      show: _unref(showLinkedInConnectionModal),
      "contact-name": contactFullName.value,
      "is-loading": _unref(isSendingLinkedInInvite),
      error: _unref(linkedInInviteError),
      onClose: _unref(handleLinkedInConnectionModalClose),
      onSend: _unref(handleLinkedInConnectionSend)
    }, null, 8, ["show", "contact-name", "is-loading", "error", "onClose", "onSend"]),
    _createVNode(AIPersonalizationModal, {
      "show-modal": showAiPersonalizationModal.value,
      "contact-name": aiPersonalizationContext.value.contactName,
      "icp-name": aiPersonalizationContext.value.icpName,
      "default-type": aiPersonalizationContext.value.defaultType as any,
      "contact-id": aiPersonalizationContext.value.contactId,
      "icp-id": aiPersonalizationContext.value.icpId,
      onClose: _cache[44] || (_cache[44] = ($event: any) => (showAiPersonalizationModal.value = false))
    }, null, 8, ["show-modal", "contact-name", "icp-name", "default-type", "contact-id", "icp-id"]),
    _createVNode(StartWhatsAppChatModal, {
      show: _unref(showStartChatModal),
      channels: _unref(availableChannelsForChat) as any,
      "default-account-id": _unref(getChannelForType)(_unref(activeInteractionTab))?.accountId,
      "is-loading": _unref(isCreatingChat),
      "auto-set-channel-type": 
        _unref(activeInteractionTab) === 'whatsapp' || _unref(activeInteractionTab) === 'linkedin'
          ? _unref(activeInteractionTab)
          : undefined
      ,
      "hide-account-selection": true,
      "contact-phone-numbers": _unref(activeInteractionTab) === 'whatsapp' ? _unref(contactPhoneNumbers) : undefined,
      "contact-id": _unref(reactiveContact)?.id || __props.selectedBucket?.contactId,
      "icp-id": icps.value?.find((i) => i.isDefault)?.id,
      onClose: _cache[45] || (_cache[45] = ($event: any) => (showStartChatModal.value = false)),
      onCreateChat: _unref(handleCreateChat)
    }, null, 8, ["show", "channels", "default-account-id", "is-loading", "auto-set-channel-type", "contact-phone-numbers", "contact-id", "icp-id", "onCreateChat"]),
    _createVNode(ConnectChannelModal, {
      show: _unref(showConnectChannelModal),
      channel: _unref(channelToConnect),
      "is-loading": _unref(isConnectingChannel),
      onClose: _cache[46] || (_cache[46] = ($event: any) => (showConnectChannelModal.value = false)),
      onConnect: _unref(handleConnectChannel)
    }, null, 8, ["show", "channel", "is-loading", "onConnect"]),
    _createVNode(LinkedInProfileViewerModal, {
      show: _unref(showLinkedInProfileModal),
      selectedBucket: __props.selectedBucket,
      linkedInChannel: _unref(linkedInChannel),
      onClose: _cache[47] || (_cache[47] = ($event: any) => (showLinkedInProfileModal.value = false))
    }, null, 8, ["show", "selectedBucket", "linkedInChannel"]),
    _createVNode(CompanyProfileViewerModal, {
      show: _unref(showCompanyProfileModal),
      selectedBucket: __props.selectedBucket,
      linkedInChannel: _unref(linkedInChannel),
      onClose: _cache[48] || (_cache[48] = ($event: any) => (showCompanyProfileModal.value = false))
    }, null, 8, ["show", "selectedBucket", "linkedInChannel"]),
    (_unref(isPostCallLocked) && !_unref(isDispositionPending))
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[51] || (_cache[51] = [
          _createElementVNode("div", { class: "post-call-loading-card" }, [
            _createElementVNode("div", { class: "post-call-loading-spinner" }),
            _createElementVNode("p", { class: "post-call-loading-text" }, "Preparing call summary...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (_unref(isDispositionPending) && _unref(pendingCallSid))
      ? (_openBlock(), _createBlock(CallDispositionRequiredModal, {
          key: 12,
          "call-sid": _unref(pendingCallSid),
          onSaved: _unref(onDispositionSaved)
        }, null, 8, ["call-sid", "onSaved"]))
      : _createCommentVNode("", true)
  ]))
}
}

})